import { DataFilter } from '@siclop/kstone-vue'

export class ActivityFilter extends DataFilter {
  projectId?: number
  lotId?: number
  userId?: number
  activityTypeId?: number
  dateFrom?: Date
  dateTo?: Date
  isBillable?: boolean
  isInvoiced?: boolean

  constructor(data?: Partial<ActivityFilter>) {
    super(data)
    if (data) {
      this.projectId = data.projectId
      this.lotId = data.lotId
      this.userId = data.userId
      this.activityTypeId = data.activityTypeId
      this.dateFrom = data.dateFrom
      this.dateTo = data.dateTo
      this.isBillable = data.isBillable
      this.isInvoiced = data.isInvoiced
    }
  }

  override toQueryString(): string {
    let qs = super.toQueryString()
    const params: string[] = []
    if (this.projectId) params.push(`ProjectId=${this.projectId}`)
    if (this.lotId) params.push(`LotId=${this.lotId}`)
    if (this.userId) params.push(`EmployeeId=${this.userId}`)
    if (this.activityTypeId) params.push(`ActivityTypeId=${this.activityTypeId}`)
    if (this.dateFrom) params.push(`DateFrom=${this.dateFrom.toISOString()}`)
    if (this.dateTo) params.push(`DateTo=${this.dateTo.toISOString()}`)
    if (this.isBillable !== undefined) params.push(`IsBillable=${this.isBillable}`)
    if (this.isInvoiced !== undefined) params.push(`IsInvoiced=${this.isInvoiced}`)
    if (params.length > 0) {
      qs += (qs ? '&' : '?') + params.join('&')
    }
    return qs
  }
}
